import { CertificateOut } from '../types/apiRequests'

export const getInstance = (record: CertificateOut | undefined): string => {
    if (record?.metaData) {
        return (record.metaData as { instanceName: string }).instanceName || ''
    }
    return ''
}
